export default __webpack_public_path__ + "static/media/Sielanka_63.e819d9a1.jpg";